import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Paste YOUR specific config object here
const firebaseConfig = {
  apiKey: "AIzaSyBisTeZrVnBYZxKgIFyfeG8OtkRuFBSJXw",
  authDomain: "barberapp-d5305.firebaseapp.com",
  projectId: "barberapp-d5305",
  storageBucket: "barberapp-d5305.firebasestorage.app",
   appId: "1:526464815128:web:cd40a48d67716658f7336d",
  measurementId: "G-T5DM19EYHK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Export tools for use in our components
export const auth = getAuth(app);
export const db = getFirestore(app);